var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticStyle:{"background-color":"#fafafa"},attrs:{"flat":""}},[_c('v-toolbar-title',[_c('h2',[_vm._v(_vm._s(_vm.typeReporting))])]),_c('v-spacer'),_c('app-timeselector',{attrs:{"dateonefromurl":_vm.dateonefromurl,"datetwofromurl":_vm.datetwofromurl},on:{"datesUpdate":_vm.datesUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }